import { useSelector } from 'react-redux';
import { commonItemPropType } from '../../declarations.propTypes';
import endpoints from '@app/constants/endpoints';
import { replaceTokensInUrl } from '@app/utils';
import { normalizeUrl } from '@app/utils';
import { MY_ACCOUNT_SEARCH } from '@app/constants/routes';

const SavedListLink = ({ item }) => {
  const { createdBy, orderId, name } = item;
  const storeId = useSelector(s => s.common.storeId);
  const catalogId = useSelector(s => s.common.catalogId);
  const langId = useSelector(s => s.common.langId);
  const savedDetailPageLink = replaceTokensInUrl(
    normalizeUrl(endpoints.SAVED_LIST_DETAIL_URL),
    catalogId,
    langId,
    storeId,
    createdBy,
    orderId,
    name,
    MY_ACCOUNT_SEARCH.LIST_DETAILS
  );
  return (
    <a
      className="exclude-global text-start text-break"
      href={savedDetailPageLink}
    >
      {name}
    </a>
  );
};
export default SavedListLink;

SavedListLink.propTypes = {
  item: commonItemPropType
};
